import { css } from '@emotion/css';

const style =  {
    container: css({
        backgroundColor: '#000'
    }),
};

export default style;